import * as Action from "@actions/index";

const InitialState = {
  status: "waiting",
  data: null,
  error: null,
};

export default function StanSelected(state = InitialState, action: any) {
  switch (action.type) {
    case Action.Stand.Selected.SET_DATA:
      return { ...state, data: action.data };
    case Action.Stand.Selected.SET_STATUS:
      return { ...state, status: action.data };
    case Action.Stand.Selected.SET_ERROR:
      return { ...state, error: action.data };
    case Action.Stand.Selected.CLEAR:
      return { ...state, data: null };
    default:
      return state;
  }
}
